var map = {
	"./1-4_дачные_1991.jpg": 1421,
	"./1980_balakovo_ges_big.jpg": 8370,
	"./1980_balashov.jpg": 9283,
	"./1980_hvalynsk_n17_big.jpg": 5235,
	"./1980_red_october_mid_big.jpg": 2038,
	"./1980_red_october_near_big.jpg": 4665,
	"./1980_tersa_big.jpg": 1602,
	"./1987_ozerki_big.jpg": 4715,
	"./1990_lastochka_big.jpg": 1593,
	"./1991_balakovo_blue_bird_big.jpg": 7072,
	"./1991_hvalynsk_big.jpg": 2736,
	"./1991_idolga_big.jpg": 1453,
	"./1992_socol_big.jpg": 4565,
	"./1996_colotov_big.jpg": 486,
	"./1997_urickoe_inyaki_1_big.jpg": 4085,
	"./1997_urickoe_inyaki_big.jpg": 9761,
	"./1998_beem_tollegina_big.jpg": 4951,
	"./1999_Svetoch_big.jpg": 3179,
	"./1999_malin_big.jpg": 825,
	"./1999_shiroky_big.jpg": 8399,
	"./2000_ataevka_big.jpg": 4554,
	"./2000_byrkin_big.jpg": 9048,
	"./2001_beem_diyakonova_big.jpg": 252,
	"./2001_red_textile_worker_big.jpg": 5813,
	"./2001_svetoch_big.jpg": 7414,
	"./2002_svetoch_big.jpg": 8115,
	"./3-9_дачные_1999.jpg": 6820,
	"./IVANOVSKIY_98_BIG.jpg": 522,
	"./KISLOVO_91_BIG.jpg": 2159,
	"./KOROLIKOV_SAD_BIG.jpg": 1034,
	"./KRASNYE_PESKI_85_BIG.jpg": 5683,
	"./LUGANSKOE_94_BIG.jpg": 4876,
	"./MORDOVOE_95_BIG.jpg": 1121,
	"./SERGEEVSKIY_1_BIG.jpg": 3790,
	"./SHIROKIY_BUERAK_88_BIG.jpg": 3942,
	"./UNKNOWN_1_BIG.jpg": 2953,
	"./UNKNOWN_2_BIG.jpg": 7541,
	"./UNKNOWN_3_BIG.jpg": 9114,
	"./VOSKRESENSKOE_91_BIG.jpg": 8983,
	"./ads/ads-image-1.jpg": 4560,
	"./ads/Нарат-2025.jpg": 991,
	"./distance.svg": 7351,
	"./favicon.png": 3750,
	"./fomin-daniil-slider.jpg": 3902,
	"./korolev-slider.jpg": 9162,
	"./link.svg": 5333,
	"./logo.jpg": 4375,
	"./relief-bg.svg": 2969,
	"./search.svg": 8452,
	"./volga19_logo.jpg": 3752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;